export class TrancheDto {
  nominalValue: number;
  haircut: number;
}
